"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
function Pause({ className, ...rest }) {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", className: `${className != null && className}`, viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", "data-icon": "pause", focusable: "false", role: "img", ...rest },
        react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M15.75 5.25v13.5m-7.5-13.5v13.5" })));
}
exports.default = Pause;
//# sourceMappingURL=Pause.js.map